var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "btn-wrapper" },
    [
      _c(
        _vm.tag,
        _vm._g(
          _vm._b(
            {
              tag: "component",
              staticClass: "btn",
              class: "btn_" + _vm.theme,
              attrs: {
                href: _vm.href,
                to:
                  _vm.to === "not-nuxt-link" ? false : _vm.localizedLink(_vm.to)
              }
            },
            "component",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        ),
        [_c("span", { staticClass: "btn__text" }, [_vm._t("default")], 2)]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-eeaa9f4c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eeaa9f4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/_UI/BaseButton.vue
// module id = l+by
// module chunks = 13